<template>
  <Event />
</template>

<script>
import Event from '@/components/content/events/EditSelectedEvent.vue'

export default {
  name: 'ContentEventHistory',
  components: { Event }
}
</script>

<style scoped>

</style>
